import { render } from "./StoryDetailView.vue?vue&type=template&id=242763a8&scoped=true"
import script from "./StoryDetailView.vue?vue&type=script&lang=js"
export * from "./StoryDetailView.vue?vue&type=script&lang=js"

import "./StoryDetailView.vue?vue&type=style&index=0&id=242763a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-242763a8"

export default script